import React, { useState } from 'react';
import { InputAdornment, TextField as MuiTextField, Tooltip, Fade } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { withStyles } from '@mui/styles';
import { isString } from 'lodash';
import PropTypes from 'prop-types';
import { DARK_THEME_COLOR, ERROR_THEME_COLOR } from '../../../const';

const defaultInputLabelProps = {
  shrink: true,
};

const style = {
  root: {
    color: DARK_THEME_COLOR,

    '& .input-right-icon': {
      fontSize: 18,
      marginTop: 8,
    },

    '& .MuiInputLabel-root': {
      '&+.MuiInput-root .MuiInput-input': {
        marginTop: 6,
      },

      '&.Mui-error': {
        color: ERROR_THEME_COLOR,
      },

      '& .MuiInputLabel-asterisk': {
        color: ERROR_THEME_COLOR,
      },
    },
    '& .MuiInput-underline:before': {
      borderBottom: '1px solid rgb(224, 224, 224)',
    },
    // '& .MuiInput-multiline': {
    //   '& .Mui-disabled': {
    //     color: 'currentColor' // why?
    //   }
    // },
    '& .MuiInput-root': {
      color: DARK_THEME_COLOR,

      '& .MuiInput-input': {
        fontSize: 14,
        height: 20,
        marginTop: 0,
        marginBottom: 0,
        padding: 0,
      },

      '& .Mui-disabled': {
        color: 'black',
      },

      '& .MuiIconButton-edgeEnd.Mui-disabled': {
        color: 'rgba(0, 0, 0, 0.38)',
      },
    },
    '&.compact': {
      '& input': {
        fontSize: '14px',
        height: '10px',
      },
    },
  },
};

export const CustomizedTextField = withStyles(style)(MuiTextField);

export function TextField({ errorText, helperText, InputLabelProps, ...other }) {
  return (
    <CustomizedTextField
      {...other}
      helperText={isString(errorText) ? errorText : helperText}
      InputLabelProps={InputLabelProps || defaultInputLabelProps}
    />
  );
}

export function PasswordField({ input: { value, onChange }, meta: { touched, error }, label, isFetching }) {
  const [showPassword, setShowPassword] = useState(false);
  const errorText = touched && error ? error : '';

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const inputProps = {
    endAdornment: (
      <InputAdornment position="end" style={{ height: '100%', cursor: 'pointer' }}>
        <Tooltip
          title={showPassword ? 'Hide Password' : 'Show Password'}
          TransitionComponent={Fade}
          TransitionProps={{ timeout: 600 }}
          arrow
          placement="right"
        >
          <div
            onClick={handleClickShowPassword}
            onMouseDown={handleMouseDownPassword}
            className="input-right-icon"
            style={{ padding: '0 5' }}
          >
            {!showPassword ? <VisibilityOff fontSize="inherit" /> : <Visibility fontSize="inherit" />}
          </div>
        </Tooltip>
      </InputAdornment>
    ),
  };

  return (
    <TextField
      onChange={onChange}
      value={value}
      fullWidth
      disabled={isFetching}
      label={label}
      type={showPassword ? 'text' : 'password'}
      error={!!(touched && error)}
      errorText={errorText}
      InputProps={inputProps}
    />
  );
}

export function FormInput(props) {
  const {
    input: { value, onChange },
    meta: { touched, error },
    label,
    type,
    isFetching,
  } = props;
  const errorText = touched && error ? error : '';

  return (
    <TextField
      onChange={onChange}
      value={value}
      fullWidth
      disabled={isFetching}
      label={label}
      type={type}
      error={!!(touched && error)}
      errorText={errorText}
    />
  );
}

TextField.propTypes = {
  autoFocus: PropTypes.bool,
  value: PropTypes.any,
  label: PropTypes.node,
  helperText: PropTypes.node,
  name: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  errorText: PropTypes.string,
  multiline: PropTypes.bool,
  fullWidth: PropTypes.bool,
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
  onChange: PropTypes.func,
  inputProps: PropTypes.any,
};

TextField.defaultProps = {
  type: 'text',
  required: false,
  disabled: false,
  error: false,
  multiline: false,
  fullWidth: false,
};

export default TextField;
